import { ITEM_DATA_TAB_MESSAGES, ItemDataTabMessages } from "./item-data-tab.messages";
import {
  ORDER_COMMENTS_TAB_MESSAGES,
  OrderCommentsTabMessages,
} from "./order-comments-data-tab.messages";
import { ORDER_DATA_TAB_MESSAGES, OrderDataTabMessages } from "./order-data-tab.messages";
import { HISTORY_DATA_TAB_MESSAGES, HistoryDataTabMessages } from "./order-history-tab.messages";
import { PAYMENT_DATA_TAB_MESSAGES, PaymentDataTabMessages } from "./payment-data-tab.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";

export type OrderFormPageMessages = SidebarMessages &
  ActionButtonMessages &
  OrderDataTabMessages &
  ItemDataTabMessages &
  PaymentDataTabMessages &
  HistoryDataTabMessages &
  OrderCommentsTabMessages & {
    // Titles
    editTitle: string;
    createTitle: string;
    cardTitle: string;
    orderBreadCrumbTitle: string;

    //Tab Titles
    orderDetailsTabLabel: string;
    orderItemsTabLabel: string;
    orderPaymentsTabLabel: string;
    orderHistoryTabLabel: string;
    orderCommentsTabLabel: string;

    //Error Messages
    notFoundError: string;
    notFoundAlt: string;
  };

export const ORDER_FORM_PAGE_MESSAGES: OrderFormPageMessages = {
  // Titles
  editTitle: "Editar Pedido",
  createTitle: "Criar Pedido",
  cardTitle: "Pedido",
  orderBreadCrumbTitle: "Pedidos",

  //Tab Titles
  orderDetailsTabLabel: "Dados do Pedido",
  orderItemsTabLabel: "Itens do Pedido",
  orderPaymentsTabLabel: "Pagamentos",
  orderHistoryTabLabel: "Histórico",
  orderCommentsTabLabel: "Comentários",

  //Error Messages
  notFoundError: "Pedido não encontrado",
  notFoundAlt: "Pedido não encontrado alternativa",

  ...ORDER_COMMENTS_TAB_MESSAGES,
  ...SIDEBAR_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
  ...ORDER_DATA_TAB_MESSAGES,
  ...ITEM_DATA_TAB_MESSAGES,
  ...PAYMENT_DATA_TAB_MESSAGES,
  ...HISTORY_DATA_TAB_MESSAGES,
};
